<template>
  <div class="filler-box" id="home-filler-box" :style="style">
    <template v-for="index in showIndexes">
      <i
        :class="'fa fa-' + $t('home_promote_icon_' + index)"
        :key="index"
      />
      {{ $t('home_promote_text_' + index) !== 'home_promote_text_' + index ? $t('home_promote_text_' + index) : '' }}
    </template>
    <div
      v-if="skipAutoHeight"
      class="py-2 d-block"
    >&nbsp;</div>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'DynamicAutoHeightInfoBox',

  props: {
    showIndexes: {
      type: Array,
      default: () => { return [1, 2, 3, 4, 5, 6, 7] },
    },
    skipAutoHeight: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      offsetTop: 0,
      height: 100,
      timer: null
    }
  },

  created () {
    setTimeout(() => {
      this.setHeight()
    }, 200)
  },

  destroyed () {
    clearTimeout(this.timer)
  },

  mounted () {
    this.$nextTick(() => {
      this.setHeight()
    })
  },

  computed: {
    ...mapFields(Object.keys(state)),

    style () {
      const style = {}
      if (this.offsetTop > 0) {
        style.height = this.height + 'px'
      }
      return style
    }
  },

  methods: {
    setHeight () {
      if (this.$store.state.progressSearching) {
        this.timer = setTimeout(() => {
          this.setHeight()
        }, 50)
        return
      }
      if (this.skipAutoHeight) { return }
      const minusHeight = 130
      const el = document.getElementById('home-filler-box')
      if (!el) { return }
      this.offsetTop = el.offsetTop
      this.height = (document.body.scrollHeight - this.offsetTop - minusHeight)
      this.timer = setTimeout(() => {
        this.setHeight()
      }, 50)
    }
  }
}
</script>

<style>
.filler-box {
  max-width: 237px;
  border-radius: 6px;
  text-align: center;
  background: #eee;
  padding: 10px;
  margin-top: 15px;
  overflow: hidden;
  color: #888;
  font-size: 16px;
}
.filler-box i {
  padding: 40px 0 25px 0;
  color: #ccc;
  clear: both;
  width: 100%;
  font-size: 50px;
}
</style>
